"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerIcon = void 0;
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var moment_1 = __importDefault(require("moment"));
var styles = __importStar(require("./DatePicker.module.css"));
var DatePickerIcon = (function (_super) {
    __extends(DatePickerIcon, _super);
    function DatePickerIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.pdf = document.body.classList.contains("pdf");
        _this.enterKeyEvent = _this.enterKeyEvent.bind(_this);
        _this.changeFocus = _this.changeFocus.bind(_this);
        return _this;
    }
    DatePickerIcon.prototype.changeFocus = function (nextInputId) {
        var nextInputRef = document.getElementById(nextInputId);
        if (nextInputRef) {
            nextInputRef.focus();
        }
    };
    DatePickerIcon.prototype.enterKeyEvent = function (event) {
        if (event.key == "Enter" && this.props.nextInputId) {
            this.changeFocus(this.props.nextInputId);
        }
    };
    DatePickerIcon.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, _b = _a.errors, errors = _b === void 0 ? {} : _b, classNameWrap = _a.classNameWrap, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, dateParams = _a.dateParams, inputName = _a.inputName;
        var jsonId = inputName ? inputName : id;
        var value = json_data[jsonId] || "";
        var error = errors[jsonId];
        var classRoot = "".concat(styles.root, " ").concat(className);
        if (error) {
            classRoot = "".concat(classRoot, " ").concat(styles.rootError);
        }
        if (this.pdf) {
            value = (0, moment_1.default)(json_data[jsonId]).format("MM/DD/YYYY");
        }
        var convertValue = value;
        if (!convertValue)
            convertValue = undefined;
        var CustomIcon = function (props) {
            return (React.createElement("div", { className: "".concat(classNameWrap, " DatePicker_wrapper") },
                React.createElement("div", { className: "col-xs-9" },
                    React.createElement("input", { id: "".concat(id), className: classRoot, value: props.value })),
                React.createElement("div", { className: "col-xs-2" },
                    React.createElement("span", { onClick: props.onClick },
                        React.createElement("img", { src: "/img/calendar.svg", height: "20", width: "20" })))));
        };
        return (React.createElement("div", { className: "".concat(classNameWrap, " DatePicker_wrapper") },
            React.createElement(react_datepicker_1.default, __assign({ id: id, selected: Date.parse(convertValue), onChange: function (date) {
                    onChange(jsonId, date);
                }, name: jsonId, className: classRoot, readOnly: disabled, onKeyDown: this.enterKeyEvent, customInput: React.createElement(CustomIcon, null) }, dateParams)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePickerIcon;
}(React.Component));
exports.DatePickerIcon = DatePickerIcon;
//# sourceMappingURL=data:application/json;base64,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